import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { hasSchemaACL, isWeaveUser } from '@frontend/auth-helpers';

export type GetPermittedLocationsStrategy = 'any' | 'all';

type GetPermittedLocationsOptions = {
  allowWeaveUser?: boolean;
  strategy?: GetPermittedLocationsStrategy;
};

export const getPermittedLocations = (
  locationIds: string[],
  permissions: Permission | Permission[],
  { allowWeaveUser = true, strategy = 'all' }: GetPermittedLocationsOptions = {}
) => {
  const allowedWeaveUser = allowWeaveUser && isWeaveUser();
  const permittedLocations = locationIds.filter((location) => hasSchemaACL(location, permissions) || allowedWeaveUser);

  const hasPermission =
    strategy === 'all'
      ? locationIds.length > 0 && permittedLocations.length === locationIds.length
      : permittedLocations.length > 0;

  return { hasPermission: hasPermission, permittedLocations };
};
